import React from 'react';
import LoginForm from '../../components/user/login-form';
import * as userActions from '../../actions/users';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PageContainer from '../page-container';

class LoginContainer extends PageContainer {
    onSuccessSubmit() {
        window.USER_LOGGED = true;
        this.openPage('/admin/');
    }
    render() {
        const {actions} = this.props;

        return (
            <div className="login">
                <div className="container">
                    <div className="logo-wrapper">
                        <img src={require('../../../images/eventomania-dark.png')}/>
                    </div>
                    <LoginForm submit={actions.login} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></LoginForm>
                </div>

            </div>
        )
    }
}
export default connect(function() {
    return {}
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions
        }, dispatch)
    };
})(LoginContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/login-container.js